<div class="avatar">
  <common-mojo-avatar
    [id]="company.logoId"
    [initials]="company.name.substring(0,2)"
    [selectedPhotoShape]="avatarShape"
    [backgroundSize]="avatarBackgroundSize"
    data-cy="user-card-avatar"
  >
  </common-mojo-avatar>
</div>
<div class="company-data font-regular font-weight-normal">
  <span
    class="name"
    data-cy="company-card-name"
  >
    <common-mojo-mark-search-phrase-box
      [markedSearchPhrase]="markedSearchPhrase"
      [text]="company.name"
    >
    </common-mojo-mark-search-phrase-box>
  </span>
  <span class="address">
    <ng-container *ngIf="company.city">
      {{ company.city }},
    </ng-container>
    <ng-container *ngIf="company.countryCode">
      {{ company.countryCode }}
    </ng-container>
  </span>
</div>
